export default __webpack_public_path__ + "static/media/1005.b747de48.svg";